export const AUTHORITY_SKILLS_QUESTION = 'Ever heard of "authority skills"?'

export const AUTHORITY_SKILLS_OPTIONS = [
  { key: 'moreThanIdLike', i18nKey: 'moreThanIdLike' },
  { key: 'sometimesButITryToStop', i18nKey: 'sometimesButITryToStop' },
  { key: 'almostNever', i18nKey: 'almostNever' },
] as const
